import icAlignLeft from "assets/icons/setting/ic_align_left.svg";
import icAlignRight from "assets/icons/setting/ic_align_right.svg";
import icCollapse from "assets/icons/setting/ic_collapse.svg";
import icContrastBold from "assets/icons/setting/ic_contrast_bold.svg";
import icContrast from "assets/icons/setting/ic_contrast.svg";
import icExitFullScreen from "assets/icons/setting/ic_exit_full_screen.svg";
import icFullScreen from "assets/icons/setting/ic_full_screen.svg";
import icMoon from "assets/icons/setting/ic_moon.svg";
import icSetting from "assets/icons/setting/ic_setting.svg";
import icSun from "assets/icons/setting/ic_sun.svg";
import bgPlaceholder from "assets/background/placeholder.svg";
import illustrationDocs from "assets/illustrations/illustration_docs.svg";
import illustrationEmptyCart from "assets/illustrations/illustration_empty_cart.svg";
import illustrationEmptyContent from "assets/illustrations/illustration_empty_content.svg";
import illustrationEmptyMail from "assets/illustrations/illustration_empty_mail.svg";
// navbar
import icBlog from "assets/icons/navbar/ic_blog.svg";
import icCart from "assets/icons/navbar/ic_cart.svg";
import icMail from "assets/icons/navbar/ic_mail.svg";
import icChat from "assets/icons/navbar/ic_chat.svg";
import icUser from "assets/icons/navbar/ic_user.svg";
import icFile from "assets/icons/navbar/ic_file.svg";
import icLock from "assets/icons/navbar/ic_lock.svg";
import icLabel from "assets/icons/navbar/ic_label.svg";
import icBlank from "assets/icons/navbar/ic_blank.svg";
import icKanban from "assets/icons/navbar/ic_kanban.svg";
import icFolder from "assets/icons/navbar/ic_folder.svg";
import icBanking from "assets/icons/navbar/ic_banking.svg";
import icBooking from "assets/icons/navbar/ic_booking.svg";
import icInvoice from "assets/icons/navbar/ic_invoice.svg";
import icCalendar from "assets/icons/navbar/ic_calendar.svg";
import icDisabled from "assets/icons/navbar/ic_disabled.svg";
import icExternal from "assets/icons/navbar/ic_external.svg";
import icMenuItem from "assets/icons/navbar/ic_menu_item.svg";
import icEcommerce from "assets/icons/navbar/ic_ecommerce.svg";
import icAnalytics from "assets/icons/navbar/ic_analytics.svg";
import icDashboard from "assets/icons/navbar/ic_dashboard.svg";
//flag
import icFlagVn from "assets/icons/flags/ic_flag_vn.svg";
import icFlagEn from "assets/icons/flags/ic_flag_en.svg";
// shape
import shapeAvt from "assets/svg/shape_avatar.svg";
const Svg = {
  Setting: {
    icAlignLeft,
    icAlignRight,
    icCollapse,
    icContrastBold,
    icContrast,
    icExitFullScreen,
    icFullScreen,
    icMoon,
    icSetting,
    icSun,
  },
  background: {
    bgPlaceholder,
  },
  illustration: {
    illustrationDocs,
    illustrationEmptyCart,
    illustrationEmptyContent,
    illustrationEmptyMail,
  },
  navbar: {
    icBlog,
    icCart,
    icChat,
    icMail,
    icUser,
    icFile,
    icLock,
    icLabel,
    icBlank,
    icKanban,
    icFolder,
    icBanking,
    icBooking,
    icInvoice,
    icCalendar,
    icDisabled,
    icExternal,
    icMenuItem,
    icEcommerce,
    icAnalytics,
    icDashboard,
  },
  flag: {
    icFlagVn,
    icFlagEn,
  },
  shape: {
    avatar: shapeAvt,
  },
};
export default Svg;
